<div class="flex flex-row items-center justify-between my-4 p-4">
  <div class="xs:grid flex gap-2 justify-between w-full items-center">
    <div class="flex flex-col">
      <div class="flex flex-row">
        <p class="text-base font-medium">
          {{ label | translate }}
        </p>
      </div>
      <div class="flex flex-row">
        <span class="text-gray-500 text-xs">
          {{
            isPending
              ? ('uploadProofOfPayment:pendingFile' | translate)
              : ('uploadProofOfPayment:uploadedFile' | translate)
          }}
          {{ isPending ? expirationDate : '' }}
        </span>
      </div>
    </div>

    <div class="flex flex-col grow">
      <div class="flex gt-xs:place-self-end">
        <span
          class="badge badge-{{
            isPending ? 'warning' : 'success'
          }} text-sm mr-6">
          {{
            isPending
              ? ('uploadProofOfPayment:pendingStatus' | translate)
              : ('uploadProofOfPayment:completedStatus' | translate)
          }}
        </span>
      </div>
    </div>
  </div>

  <div
    class="flex animate__animated animate__fadeIn"
    *ngIf="displayUploadButton">
    <div class="hover:shadow-sm flex">
      <div
        class="relative hover:shadow-sm flex items-center rounded-lg justify-center primary text-sm font-medium cursor-pointer px-[10px] py-[8px]">
        <input
          class="opacity-0 absolute cursor-pointer"
          [id]="'images'"
          [style.height.px]="35"
          [style.width.px]="35"
          [accept]="getAcceptedFileTypes()"
          [required]="required"
          (change)="send($event)"
          type="file"
        />
        <mat-icon
          *ngIf="!loading"
          class="icon-size-17 fa-regular fa-upload cursor-pointer"
        ></mat-icon>

        <mat-progress-spinner
          *ngIf="loading"
          [diameter]="20"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </div>
    </div>
  </div>

  <div
    class="flex m-0 animate__animated animate__fadeIn"
    *ngIf="!displayUploadButton">
    <div class="rounded-lg flex items-center hover:shadow-sm">
      <button
        mat-mini-fab
        [style.height.px]="34"
        (click)="delete()"
        class="flex flex-wrap w-[44px] bg-gray-100 rounded-lg shadow-sm content-center">
        <mat-icon
          *ngIf="!loading"
          class="flex icon-size-17 fa-regular fa-trash-can text-gray-500"
        ></mat-icon>

        <mat-progress-spinner
          *ngIf="loading"
          [diameter]="20"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>

  <mat-error *ngIf="error" class="text-red-600 text-xs">{{
    error | translate
  }}</mat-error>
</div>
